import { Link } from "react-router-dom";
import { UNITS_LIST_PATH } from "../../constants";
import "./TextbookSelectionPage.css";

function TextbookSelectionPage() {
  return (
    <div id="textbook-selection-container">
      <h1>Choose a Textbook</h1>

      <div className="textbook-button-container">
        <Link to={UNITS_LIST_PATH} state={{ textbook: "GT_textbook" }}>
          <button className="textbook-button">Old Textbook</button>
        </Link>

        <Link to={UNITS_LIST_PATH} state={{ textbook: "ttmik" }}>
          <button className="textbook-button">Talk To Me In Korean</button>
        </Link>
      </div>
    </div>
  );
}

export default TextbookSelectionPage;